import { CatalogApp } from '@/webapi/use-widget-catalog-api';

export enum Pages {
  HOME = `/`,
  DASHBOARD = `/dashboard`,
  EDITOR = `/editor`,
  EXPERIENCE_DETAILS = `/details`,
  LOGIN = `/login/`,
  PLEASE_REINSTALL = `/please-reinstall`,
  SIGN_UP = `/signup`,
  WELCOME = `/welcome`,
  AWAIT_EMAIL = `/await-email`,
  ACCOUNT_SETTINGS = `/account-settings`,
  SHOP_SETTINGS = `/shop-settings`,
  TEAMMATES = `/teammates`,
  ACCOUNTS = `/accounts`,
  THEMES = `/themes`,
  INTEGRATIONS = `/integrations`,
}

export function editorRoute(expId?: string) {
  if (expId) {
    return `${Pages.EDITOR}?expId=${expId}`;
  }
  return `${Pages.EDITOR}`;
}

export function editorRouteWithWidget(app: CatalogApp) {
  return `${Pages.EDITOR}?app=${app.id}`;
}

export function detailsRoute(expId: string) {
  return `${Pages.EXPERIENCE_DETAILS}?expId=${expId}`;
}
